export const BASE_URL = "https://sijakon.batam.go.id/admin";
// export const BASE_URL = "http://sijakon.dimazpranajaya.com/admin";
// export const BASE_URL_DEFAULT = "https://sijakon.dimazpranajaya.com";
// export const BASE_URL = "http://localhost:8000";
// export const BASE_URL_DEFAULT = "https://sijakon.dimazpranajaya.com";


